import React from 'react';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';

// ReportRuntimeStatusPanel surfaces the transient runtime state for export and
// refresh operations so operators do not have to infer whether background work finished.
const buildStatusChip = (label, status, color) => (
  <Chip
    size="small"
    label={`${label}: ${status || 'idle'}`}
    color={color}
    variant={status && status !== 'idle' ? 'filled' : 'outlined'}
  />
);

const statusColor = (status) => {
  if (status === 'completed') return 'success';
  if (status === 'failed' || status === 'expired') return 'error';
  if (status === 'running') return 'warning';
  if (status === 'queued') return 'info';
  return 'default';
};

const formatTimestamp = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString();
};

const ReportRuntimeStatusPanel = ({ exportStatus, refreshStatus, onDownload, lastRefreshedAt }) => {
  if (!exportStatus && !refreshStatus) return null;

  const formattedLastRefreshed = formatTimestamp(lastRefreshedAt);

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Runtime status
        </Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems="center">
          {exportStatus && buildStatusChip('Export', exportStatus.status, statusColor(exportStatus.status))}
          {refreshStatus && buildStatusChip('Refresh', refreshStatus.status, statusColor(refreshStatus.status))}
          {exportStatus?.status === 'completed' && exportStatus.downloadUrl && (
            <Box>
              <Button variant="outlined" size="small" onClick={onDownload}>
                Download export
              </Button>
            </Box>
          )}
        </Stack>
        <Typography variant="body2" color="text.secondary">
          Last refreshed: {formattedLastRefreshed || 'Never'}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default ReportRuntimeStatusPanel;
